import { render, staticRenderFns } from "./FarmaciaComponente.vue?vue&type=template&id=73a2cd24&scoped=true"
import script from "./FarmaciaComponente.vue?vue&type=script&lang=js"
export * from "./FarmaciaComponente.vue?vue&type=script&lang=js"
import style0 from "./FarmaciaComponente.vue?vue&type=style&index=0&id=73a2cd24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a2cd24",
  null
  
)

export default component.exports